<template lang="html">
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">New Question/Answer</p>
    </header>

    <section class="modal-card-body">
      <b-field label="Question">
        <b-input
          placeholder="e.g. What material did you use for the wig ?"
          maxlength="1000"
          v-model="question"
        ></b-input>
      </b-field>

      <b-field label="Answer">
        <b-input
          maxlength="1000"
          placeholder="e.g. Unicorn hairs"
          v-model="answer"
        ></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="createQa" type="is-success" icon-pack="mdi" icon-right="check">
          Create
        </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  props: ['askableType', 'askableId'],
  data () {
    return {
      question: null,
      answer: null
    }
  },
  methods: {
    createQa () {
      let payload = {
        askable_type:
          this.askableType.charAt(0).toUpperCase() + this.askableType.slice(1),
        askable_id: this.askableId,
        question: this.question,
        answer: this.answer
      }
      this.$store
        .dispatch('questionAnswers/create', {
          payload: payload,
          askableType: this.askableType,
          askableId: this.askableId
        })
        .then((resp) => {
          this.$emit('qaCreated', resp.data.data)
          this.$parent.close()
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response.data)
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
